export const addDataLayerEditProfile = (errMsg = "") => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState?.("page") || {}
  const eventInfo = {
    eventAction: "my account:account settings:modal:edit profile:submit",
    eventName: "my account:account settings:modal:edit profile:submit",
    eventType: "navigation",
    eventMsg: errMsg || "n/a",
    eventStatus: errMsg ? "failure" : "success",
    internalLinkName: "submit",
    internalLinkPosition: "my account",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: "my account:account settings:modal:edit profile",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  window?.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}
